import React from 'react';
import { Quotes } from '@phosphor-icons/react';

/**
 * Section Témoignages de la page d'accueil.
 * ⚠️ N'afficher QUE de vrais témoignages (Loi sur la protection du
 * consommateur — les faux avis sont interdits). La section est masquée
 * tant que la liste est vide : ajouter les citations réelles ci-dessous.
 */
const TESTIMONIALS = [
  // { name: 'Prénom N.', location: 'Québec', text: 'Citation réelle ici.' },
];

export const Testimonials = () => {
  if (TESTIMONIALS.length === 0) return null;
  return (
    <section data-testid="testimonials-section" className="py-16 px-6 bg-[#F5EDE2]">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-lg font-bold text-[#3E2723] mb-8 text-center">
          Ce que nos premiers membres en disent
        </h2>
        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((tm, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-white rounded-xl border-2 border-blue-200 p-6 flex flex-col"
            >
              <Quotes size={24} weight="fill" className="text-blue-600 mb-3" />
              <p className="text-sm text-slate-800 leading-relaxed flex-1">“{tm.text}”</p>
              <p className="mt-4 text-sm font-bold text-[#3E2723]">
                {tm.name} <span className="font-normal text-slate-500">· {tm.location}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
